// extracted by mini-css-extract-plugin
export default {"subLabel":"subLabel-XXFf"};